var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15607 12.6851V1.5C7.15607 1.22386 7.37992 1 7.65607 1H21.5C21.7762 1 22 1.22386 22 1.5V22.5C22 22.7761 21.7762 23 21.5 23H7.15607",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46594 4.65381H19.6901",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46594 7.7749H19.6901",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46594 10.896H19.6901",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5959 14.0171H19.6901",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1863 17.1382H19.6901",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14995 22.9999C9.99419 22.9999 12.2999 20.6823 12.2999 17.8234C12.2999 14.9646 9.99419 12.647 7.14995 12.647C4.30571 12.647 2 14.9646 2 17.8234C2 20.6823 4.30571 22.9999 7.14995 22.9999Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87905 20.9669V20.1988C6.44055 20.1912 5.98614 20.0541 5.72107 19.8638L5.90283 19.3546C6.17548 19.5373 6.56854 19.6819 6.99265 19.6819C7.52961 19.6819 7.89314 19.3698 7.89314 18.9366C7.89314 18.5187 7.59777 18.2599 7.03809 18.0315C6.26636 17.727 5.78999 17.3776 5.78999 16.7161C5.78999 16.085 6.23606 15.6054 6.93282 15.4912V14.7231H7.40162V15.4608C7.85527 15.476 8.16578 15.5978 8.38541 15.7272L8.19608 16.2289C8.03703 16.1375 7.72728 15.9701 7.24258 15.9701C6.66018 15.9701 6.44055 16.3202 6.44055 16.624C6.44055 17.0198 6.72077 17.217 7.3789 17.491C8.15745 17.8108 8.55127 18.2066 8.55127 18.8834C8.55127 19.484 8.13549 20.0473 7.35542 20.1759V20.9669H6.87905Z",
    fill: "#28A1D9",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.247d7e3e154d95f59a60432494840066.svg";
export { ForwardRef as ReactComponent };